import React, { PureComponent } from 'react';
import CheckDefecto from "../../../../Common/Components/CheckDefecto";

class Proceso extends PureComponent {
    constructor(props) {
        super(props);
    }
    render() {

        const { proceso } = this.props.data;
        let logo = "";
        let administradoraId, tipoProceso, nombreProceso, descripcionProceso, estaActivo = null;

        if (proceso) {
            administradoraId = proceso.AdministradoraId;
            tipoProceso = proceso.TipoProceso;
            nombreProceso = proceso.NombreProceso;
            descripcionProceso = proceso.DescripcionProceso;
            estaActivo = proceso.EstaActivo;
        }
       

        if (administradoraId == undefined) {
            logo = "";
        } else {
            switch (administradoraId) {
            case 1:
                logo = "icon-visa";
                break;

            case 2:
                logo = "image-cabal-logo procesoLogo";
                break;

            case 3:
                logo = "image-mastercard-logo-tab procesoLogo";
                break;
        
            default:
                logo = "image-AD17-logo procesoLogo";
                break;  
        }
    }


        let inconoTipo;
        let archivoNombre;
        switch (tipoProceso) {
            case 'I':
                inconoTipo = 'icono-input'
                archivoNombre = 'Archivo de Entrada'
                break;
            case 'O':
                inconoTipo = 'icono-output'
                archivoNombre = 'Archivo de Salida'
                break;
            case 'P':
                inconoTipo = 'icono-gear'
                archivoNombre = 'Otros'
                break;
        }




        return (
            <div>
                <div className="row top-separator-xs">
                    <div className="col-xs-12">
                        <div className="row bottom-separator">
                            <div className="col-xs-12">
                                <h2>
                                    Proceso
                     </h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row top-separator-xs">
                    <div className="col-xs-5">
                        <label className="label-primary">{"Marca"}</label>
                        <div className={logo}></div>
                    </div>
                </div>

                <div className="row top-separator-xs">
                    <div className="col-xs-5">
                        <label className="label-primary">{"Nombre"}</label>
                        <div><label className="label-secondary">{nombreProceso}</label></div>
                    </div>
                </div>

                <div className="row top-separator-xs">
                    <div className="col-xs-12">
                        <CheckDefecto
                            nombre={"Activo"}
                            referencia={"ACTIVO"}
                            id={"Activo"}                
                            check={estaActivo}
                            selectCheckBox={(event) => this.props.setCheck("EstaActivo", event.target.checked)}
                        />
                    </div>
                </div>

                <div className="row top-separator-xs">
                    <div className="col-xs-5">
                        <label className="label-primary">{"Descripción"}</label>
                        <div> <label className="label-secondary">{descripcionProceso}</label></div>
                    </div>
                </div>

                <div className="row top-separator-xs">
                    <div className="col-xs-12">
                        <label className="label-primary">{"Tipo de Proceso"}</label>
                        <div style={{marginLeft:"12px"}}> 
                            <div className={inconoTipo}></div> <label className="label-secondary">{archivoNombre}</label>
                        </div>
                    </div>
                </div>

            </div>
        );
    }

}

export default Proceso;